import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Container,
  Stack,
  Fade,
} from "@mui/material";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import NavBar from "../../../Components/NavBar";
import { colors } from "../../../../theme";
import { CommonBreadcrumbs } from "../../../Components/ui";
import { Path } from "../../../../static/Constants";

import {
  TermsHero,
  TermsContentCard,
  TERMS_SECTIONS,
  TermsContactNotice,
  TermsHeroSkeleton,
  TermsContentSkeleton,
} from "./components";

import "./TermsAndConditionStyle.css";

const TermsAndConditions = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  // Initialize and complete loading with safeguard timeout (never stuck on loader)
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 200);

    return () => clearTimeout(timer);
  }, []);

  const handleSearchChange = useCallback((value) => {
    setSearchQuery(value);
  }, []);

  const handleClearSearch = useCallback(() => {
    setSearchQuery("");
  }, []);

  const handleScrollToSection = useCallback((sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  return (
    <Box
      id="termsScreen"
      sx={{
        bgcolor: colors.dashboard.canvas,
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <NavBar />
      <ToastContainer />

      <Container
        maxWidth="lg"
        sx={{
          pt: { xs: "96px", sm: "108px", md: "116px" },
          pb: 8,
          flexGrow: 1,
        }}
      >
        {/* Breadcrumb Navigation */}
        <CommonBreadcrumbs
          items={[
            { label: "Home", path: Path.root },
            { label: "Terms & Conditions" },
          ]}
        />

        {isLoading ? (
          <Stack spacing={4}>
            <TermsHeroSkeleton />
            <TermsContentSkeleton />
          </Stack>
        ) : (
          <Fade in timeout={300}>
            <Stack spacing={4}>
              {/* Hero Banner with Search & Navigation */}
              <TermsHero
                searchQuery={searchQuery}
                onSearchChange={handleSearchChange}
                totalSections={TERMS_SECTIONS.length}
                onScrollToSection={handleScrollToSection}
              />

              {/* Terms Clauses Content Card */}
              <TermsContentCard
                searchQuery={searchQuery}
                onClearSearch={handleClearSearch}
              />

              {/* Legal & Compliance Contact Notice */}
              <TermsContactNotice />
            </Stack>
          </Fade>
        )}
      </Container>
    </Box>
  );
};

export default TermsAndConditions;
